import React from "react";

const Header: React.FC = () => {
  return (
    <header>
      <div className="row">
        <div className="columns large-12">
          <a href="http://www.kew.org/">
            <span className="kew-logo">
              <img src="/assets/default/images/kew-logo.svg" alt="Royal Botanic Gardens, Kew"/>
            </span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;